import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Divider, Flex, useBreakpointValue, XOutline } from '@bonusly/design-system';

export interface InputControlsProps {
	onClearValue: VoidFunction;
	onClose: VoidFunction;
	value: string;
}

export const InputControls: FC<InputControlsProps> = ({ onClearValue, onClose, value }) => {
	const isAtLeastXs = useBreakpointValue({ base: false, xs: true });
	const { t } = useTranslation('common');

	if (!value && isAtLeastXs) {
		return null;
	}

	const displayDivider = !!value && !isAtLeastXs;

	return (
		<Flex alignItems="center" pr={2} pl={3}>
			{value && (
				<Button onClick={onClearValue} px={1} variant="link">
					{t('clear')}
				</Button>
			)}

			{displayDivider && <Divider color="gray.100" orientation="vertical" mx={2} />}

			{!isAtLeastXs && (
				<Flex as="button" alignItems="center" aria-label={t('close')} onClick={onClose}>
					<XOutline size="md" />
				</Flex>
			)}
		</Flex>
	);
};
